{
  "about": {
    "paragraph": "Wij zetten ons in om de uitdagingen van de AGEC-wet aan te pakken en onze klanten te informeren over de herkomst en de milieukwaliteiten van onze producten.",
    "title": "Over"
  },
  "lastUpdate": "Datum van laatste update : ",
  "loading": {
    "dataPending": "is momenteel deze informatie aan het verzamelen",
    "pendingLocation": "Locatie in behandeling"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "Kledingproductie",
    "FOOTWEAR_FINISHING": "Afwerking van schoeisel",
    "FOOTWEAR_STITCHING": "Stikken van schoeisel",
    "FOOTWEAR_ASSEMBLING": "Montage van schoeisel",
    "FABRIC_WEAVING_OR_KNITTING": "Weven of breien van stof",
    "FABRIC_DYEING_PRINTING": "Verven of bedrukken van stof",
    "YARN_PROVIDER": "Garenleverancier",
    "YARN_DYEING_PRINTING": "Verven of bedrukken van garen",
    "LEATHER_TANNING": "Leerlooien",
    "LEATHER_DYEING_PRINTING": "Verven of bedrukken van leer",
    "ACCESSORY_PROVIDER": "Accessoireleverancier",
    "YARN_MATERIAL_PRODUCTION": "Productie van garenmateriaal",
    "FABRIC_SPINNING": "Vezelspinnen",
    "FABRIC_MATERIAL_PRODUCTION": "Productie van stofmateriaal",
    "LEATHER_MATERIAL_PRODUCTION": "Productie van leermateriaal",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "Leverancier van grondstoffen voor accessoires",
    "COATING": "Coating"
  },
  "other": {
    "microplastics_bold": "stoot microplastics uit ",
    "paragraph1": "Dit product bevat ",
    "paragraph1_100": "Dit product bevat 100% gerecyclede materialen.",
    "paragraph2_1": "Dit product ",
    "paragraph2_2": "  in het milieu tijdens het wassen: ",
    "paragraph2_3": "naar massa van het product bestaat uit synthetische vezels.",
    "paragraph3": "Informatie over de mogelijke aanwezigheid van gevaarlijke stoffen in de toepassing: ",
    "recycled_matertials_bold": "ten minste {{percent}}% gerecyclede materialen.",
    "recycled_matertials_bold_50": "meer dan 50% ",
    "title": "Andere milieukwaliteiten en kenmerken"
  },
  "packaging": {
    "recyclable": "Recyclebaar: Verpakking is recyclebaar.",
    "recycled": "Gerecyclede materialen: Verpakking bevat ten minste {{percent}}% gerecyclede materialen.",
    "recycled_100": "Gerecyclede materialen: Verpakking bevat 100% gerecyclede materialen.",
    "title": "Milieukwaliteiten en kenmerken van de verpakking"
  },
  "title": "Productfiche over milieukwaliteiten of -kenmerken",
  "traceability": {
    "paragraph": "Dit verwijst naar de herkomst van uw product in de eerste drie productiestadia, van de creatie tot het weven en verven van het hoofdmaterial.",
    "title": "Producttraceerbaarheid"
  },
  "ecoScore": {
    "title": "EcoScore"
  }
}
